import {Component} from "react";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

import Grid from "../grid/Grid";
import { getGrid } from "../../store/slices/grids";
import Header from "../header/Header";
import {getDashboard} from "../../store/slices/dashboard";
import {getBrandSettings} from "../../store/slices/brandsettings";
import NotFound from "../not-found/NotFound";
import {IBrandSettings, IDashboardConfig, IGridConfig} from "../../constants/interfaces";

type Props = {
	// injected
	data: IDashboardConfig,
	dashboardId : string | null,
	isLoading: boolean,
	brandSettings: IBrandSettings,
	isLoadingSettings: boolean,
	widgets: IGridConfig,
	error: Object,
	dispatch: Function,
	match: {
		params: {id: string}
	}
};

type State = {
	interval: number | null,
	versionTest: boolean,
	dashboardId: string
};

class Dashboard extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			interval: null,
			versionTest : false,
			dashboardId : ""
		}
	}

	componentDidMount() {
		if(window.location.search === "?version=test") {
			this.setState({
				versionTest : true
			})
		}
		const auth = this.props.dispatch(getBrandSettings());
		auth.then(() => this.props.dispatch(getDashboard(this.props.match.params.id, this.state.versionTest)));
		document.body.classList.add(this.props.data.theme);
		const interval = window.setInterval(() => {
			this.props.dispatch(getDashboard(this.props.match.params.id, this.state.versionTest));
		}, 60000);
		this.setState({interval});
		
	}
	
	componentDidUpdate(prevProps: Props, prevState: State) {
		if (!isEqual(prevProps.data, this.props.data)) {
			this.props.dispatch(getGrid(this.props.data.grid_type_id));
		}
		
		if (!isEqual(prevProps.match.params.id, this.props.match.params.id)) {
			this.props.dispatch(getDashboard(this.props.match.params.id, this.state.versionTest));
		}
		
	}

	componentWillUnmount() {
		if (typeof this.state.interval === "number") {
			window.clearInterval(this.state.interval);
		}
	}

	render() {
		const data = this.props.data;
		
		if (this.props.error)  {
			
			return <NotFound/>
		} 


		return (
			<div key={this.props.match.params.id}>
				<Header
					data={data}
					theme={this.props.data.theme}
					brand={this.props.brandSettings}
					hasNavigation
				/>
				<Grid widgets={this.props.widgets} grid_type_id={data.grid_type_id} key={this.props.match.params.id}/>
				{/* {
					this.props.isLoading ? <></> :
					<Grid widgets={this.props.widgets} grid_type_id={data.grid_type_id} />
				} */}
				{/*<Notice active={!!this.props.error}/>*/}
			</div>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		data: state.dashboard.data,
		isLoading: state.dashboard.isLoading,
		dashboardId : state.dashboard.currentDashboardId,
		widgets: state.dashboard.widgets,
		error: state.dashboard.error,
		brandSettings: state.brandsettings.data,
		isLoadingSettings: state.brandsettings.isLoading
	};
}

export default connect(mapStateToProps)(Dashboard);
